export default __webpack_public_path__ + "static/image 3-f0abd80542b6ebd838b191ed3068ab8f.png";